/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterChildBalanceLogDto } from '../../models/center-child-balance-log-dto';

export interface UserCenterChildControllerFindAllBalance$Params {
  centerChildId: string;
}

export function userCenterChildControllerFindAllBalance(http: HttpClient, rootUrl: string, params: UserCenterChildControllerFindAllBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterChildBalanceLogDto>>> {
  const rb = new RequestBuilder(rootUrl, userCenterChildControllerFindAllBalance.PATH, 'get');
  if (params) {
    rb.query('centerChildId', params.centerChildId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterChildBalanceLogDto>>;
    })
  );
}

userCenterChildControllerFindAllBalance.PATH = '/api/center-child/user/balance';
